// SQR-13814: the only file that spells the frame loader's message names and
// payload shapes. Transport lives in widgetMessaging.{web,native}.ts.
export const WIDGET_MESSAGES = {
  appLoadStart: 'squire_app_load_start',
  appInitialData: 'squire_app_initial_data',
  widgetLoaded: 'squire_widget_loaded',
  dataRefresh: 'squire_data_refresh',
  widgetShown: 'squire_widget_shown',
  closeWidget: 'close_squire_widget',
  requestConsent: 'squire_request_cookie_consent_from_parent',
  passConsent: 'squire_pass_cookie_consent_to_iframe',
  setConsent: 'squire_set_cookie_consent_to_parent',
} as const;

export type WidgetMessageName =
  (typeof WIDGET_MESSAGES)[keyof typeof WIDGET_MESSAGES];

export type WidgetMessageHandler = (value: unknown) => void;

export interface DataRefreshLanguagesPayload {
  brand: { settings: { defaultLanguage: string } } | null;
  shop: { settings: { defaultLanguage: string } } | null;
  barber: { defaultLanguage: string } | null;
}

// Sent by the WaitingRoom when settings cannot be loaded; the host falls back
// to its default button language (water-on-web parity).
export interface DataRefreshDefaultPayload {
  default: true;
}

export type DataRefreshPayload =
  | DataRefreshLanguagesPayload
  | DataRefreshDefaultPayload;
